
import React from 'react';

const RelatedLinksSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">関連リンク</h2>
          <p className="text-xl sm:text-lg text-gray-600">詳細情報・公式サイト</p>
        </div>

        <div className="bg-gray-50 rounded-2xl p-8 text-center">
          <div className="w-16 h-16 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6 mx-auto">
            <i className="ri-external-link-line text-3xl text-[#76B947]"></i>
          </div>
          
          <h3 className="text-2xl font-bold text-[#2A6041] mb-4">農業ドローン協議会公式サイト</h3>
          <p className="text-gray-600 mb-6 leading-relaxed">
            技能認定制度の詳細、最新情報、その他の認定教習所情報などは<br />
            農業ドローン協議会の公式サイトでご確認いただけます。
          </p>
          
          <a 
            href="https://utcagri.aeroentry.jp/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 bg-[#76B947] text-white rounded-lg hover:bg-[#5a8a35] transition-colors font-bold text-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line mr-2"></i>
            公式サイトを見る
          </a>
          
          <p className="text-sm text-gray-500 mt-4">
            ※外部サイトに移動します
          </p>
        </div>
      </div>
    </section>
  );
};

export default RelatedLinksSection;
